import { lazy } from "react";



export const swmRoutes = [
 
    { path: "/binBagInstallation", component: lazy(() => import("../../swm/binBagInstallation")) },
    { path: "/greenAmbassadorEnrollment", component: lazy(() => import("../../swm/greenAmbassadorEnrollment")) },
    { path: "/pitMasterRegistration", component: lazy(() => import("../../swm/PitMasterRegistration")) },
    { path: "/targetPits", component: lazy(() => import("../../swm/TargetPits")) },
    { path: "/binbaginstallationreport", component: lazy(() => import("../../swm/binBagInstallationReport")) },
    { path: "/pitMasterRegistrationReport", component: lazy(() => import("../../swm/PitMasterRegistrationReport")) },
    { path: "/greenAmbassadorReport", component: lazy(() => import("../../swm/GreenAmbassadorReport")) },
    { path: "/fortnightlywetWastecollection", component: lazy(() => import("../../swm/FortnightlyWetWasteCollection")) },
    { path: "/vermiCompostStockEntry", component: lazy(() => import("../../swm/VermiCompostStockEntry")) },
    // { path: "/vermiCompostPanchayatReport", component: lazy(() => import("../../swm/VermiCompostPanchayatReport")) },
    { path: "/vermiCompostReport", component: lazy(() => import("../../swm/VermiCompostStockReport")) },
    { path: "/inspectionstatus", component: lazy(() => import("../../swm/InspectionStatus")) },
    { path: "/earthwormseeding", component: lazy(() => import("../../swm/EarthwormSeeding")) },

    
    { path: "/srVehicleRegistration", component: lazy(() => import("../../swm/SrVehicleRegistration")) },
    // { path: "/wasteToWealthGeneration", component: lazy(() => import("../../swm/WasteToWealthGeneration")) },


];
